module.exports = __webpack_public_path__ + "assets/img/twilight-solar.526a237c.jpg";